<template>
  <transition name="zoom-fade">
    <div v-if="visible" class="dialog">
      <div v-if="layout == 'default'" class="dialog-container" :class="`dialog-layout-${layout}`">
        <div v-if="icon" class="dialog-icon" :class="icon"></div>
        <div class="dialog-body">
          <div v-if="title" class="dialog-title">{{ title }}</div>
          <div v-if="message" class="dialog-message">{{ message }}</div>
        </div>
      </div>
      <div v-if="layout == 'wait'" class="dialog-container" :class="`dialog-layout-${layout}`">
        <div v-if="title" class="dialog-title">{{ title }}</div>
        <div v-if="icon" class="dialog-icon" :class="icon"></div>
        <div class="dialog-message">{{ message || 'しばらくこのままでお待ち下さい。' }}</div>
      </div>
      <div v-if="actions.length > 0" class="dialog-actions">
        <a v-for="(action, index) in actions" href="#" class="btn btn-sm" :class="action.class ? `btn-${action.class}` : null" @click.prevent="clickAction(action, index)">{{ action.text }}</a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: {
    dialog: {
      type: Object,
      default() {
        return {
          layout: 'default',
          title: null,
          message: null,
          icon: null,
          actions: [],
          onCreated: null,
          onOpen: null,
          promise: null,
          key: null,
        }
      },
    }
  },
  data() {
    return {
      visible: false,
      ...this.dialog
    }
  },
  created() {
    if (this.onCreated) {
      this.onCreated(this)
    }
  },
  mounted() {
    this.open()
  },
  methods: {
    ...mapActions('dialog', [
      'removeDialog',
    ]),
    open() {
      return new Promise(resolve => {
        this.visible = true
        if (this.onOpen) {
          this.onOpen(this)
        }
        resolve()
      })
    },
    close() {
      return new Promise(resolve => {
        this.visible = false
        setTimeout(() => {
          this.removeDialog(this.key)
          resolve()
        }, 200)
      })
    },
    clickAction(action, index) {
      this.promise.resolve({
        dialog: this,
        action,
        index,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -94px;
  margin-left: -209px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 418px;
  height: 188px;
  border: 4px solid #fff;
  box-shadow: 0 0 0 4px #ccc inset;
  border-radius: 10px;
  background: #fff;
}
.dialog-container {
  display: flex;
  align-items: center;
}
  .dialog-icon {
    &.exclamation {
      width: 37px;
      height: 37px;
      background: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2037%2037%22%20width%3D%2237%22%20height%3D%2237%22%3E%20%3Cpath%20fill%3D%22%23fc0%22%20d%3D%22M30.5%206.5c-3.3-3.3-7.3-5-12-4.9-4.7%200-8.7%201.6-12%204.9-3.3%203.3-5%207.4-4.9%2012%200%204.7%201.6%208.7%204.9%2012%203.3%203.3%207.4%205%2012%205%204.7%200%208.7-1.7%2012-5%203.3-3.3%205-7.3%205-12s-1.7-8.7-5-12z%22%2F%3E%20%3Cpath%20fill%3D%22none%22%20stroke%3D%22%23666%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%223%22%20d%3D%22M30.5%206.5c3.3%203.3%205%207.4%205%2012%200%204.7-1.7%208.7-5%2012-3.3%203.3-7.3%205-12%205s-8.7-1.7-12-5c-3.3-3.3-5-7.3-4.9-12%200-4.7%201.6-8.7%204.9-12%203.3-3.3%207.4-5%2012-4.9%204.7-.1%208.7%201.5%2012%204.9z%22%2F%3E%20%3Cg%3E%20%3Cg%20transform%3D%22translate(-11%20-15.45)%22%3E%20%3Cdefs%3E%20%3Cpath%20id%3D%22a%22%20d%3D%22M16.5%2016.5h27v34h-27z%22%2F%3E%20%3C%2Fdefs%3E%20%3Ctext%20fill%3D%22%23666%22%20font-family%3D%22Arial-BoldMT%22%20font-size%3D%2224%22%20transform%3D%22translate(26.35%2042.5)%22%3E%20!%20%3C%2Ftext%3E%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E');
    }
    &.saving {
      width: 120px;
      height: 34px;
      background: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20120%2034%22%20width%3D%22120%22%20height%3D%2234%22%3E%20%3Cpath%20fill%3D%22%23693%22%20d%3D%22M32.42%2033.935V19.902h8.701L20.633-.024.144%2019.902h8.701v14.033h8.42V18.78h4.771v15.155H32.42m47.011-18.383L68.064%205.308v5.754h-17.54v4.49H79.43m0%207.438V18.5H50.523L61.89%2028.742V22.99H79.43m40.275%2010.945V3.625H90.377v24.417l5.894%205.893h23.435M114.233%205.59v15.436H95.85V5.59h18.383m0%2018.944v7.438h-8.84v-4.21h-2.807v4.21h-2.526v-7.438h14.173z%22%2F%3E%3C%2Fsvg%3E');
    }
    &.printer {
      width: 29px;
      height: 33px;
      background: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2029%2033%22%20width%3D%2229%22%20height%3D%2233%22%3E%20%3Cpath%20fill%3D%22%23693%22%20d%3D%22M29.01%2017.988H26.62V.156H2.479v17.832H.089V29.73h1.087v3.044h26.53v-3.044h1.088l.218-11.743m-3.48%2011.525v.87H3.35v-.87H25.53m1.305-9.35v7.393H2.262v-7.394h24.574m-2.61-18.05v15.876H4.437V2.113h19.79m-2.393%2013.483v-1.74H7.264v1.74h14.57m0-9.351v-1.74H7.264v1.74h14.57m0%204.784v-1.74H7.264v1.74h14.57m4.132%2015.657v-6.089h-6.089v6.09h6.09z%22%2F%3E%3C%2Fsvg%3E');
    }
  }
.dialog-layout-default {
  .dialog-icon {
    flex: 1 1 auto;
    margin-right: 10px;
  }
  .dialog-body {
    flex: 1 1 auto;
  }
  .dialog-title {
    max-width: 312px;
    font-size: 18px;
  }
  .dialog-message {
    max-width: 312px;
    font-size: 12px;
  }
}
.dialog-layout-wait {
  flex-direction: column;
  .dialog-title {
    margin-bottom: 16px;
    padding: 0 8px;
    min-width: 213px;
    height: 32px;
    background: #ccc;
    border-radius: 16px;
    color: #666;
    font-size: 18px;
    line-height: 32px;
    text-align: center;
  }
  .dialog-icon {
    margin-bottom: 8px;
  }
  .dialog-message {
    font-size: 14px;
  }
}
.dialog-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  .btn {
    margin: 0 10px;
    min-width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// assets/js/components/Dialog.vue